import React, {Component} from 'react';
import data from '../../../utils/data';

class CustomValidators extends Component {

    static countryCode(control) {
        var codes = data.getCountryCodes();
        if (codes.indexOf(control.value) != -1) {
            return null;
        } else {
            return {invalidCountryCode: true}
        }
    }
}

export default CustomValidators;
